/**
 * Created by mauget on 3/22/16.
 */

import pako         from 'pako';
import Base64Decoder from 'util/Base64Decoder.js';
import CRC32  from  'crc-32/crc32.js';

//==============================================================================================
// This is a wrapper for GZIP deflation and inflation. It can inflate and default arrays
// and strings. Perfect Forms Forms XML payloads have additional header data that needs
// to be processed in order to position to the location of the GZipped form XML.
//==============================================================================================
// Byte order: Little-endian
// Offset   Length   Contents
// 0      2 bytes  magic header  0x1f, 0x8b (\037 \213)
// 2      1 byte   compression method
// 0: store (copied)
// 1: compress
// 2: pack
// 3: lzh
// 4..7: reserved
// 8: deflate
// 3      1 byte   flags
// bit 0 set: file probably ascii text
// bit 1 set: continuation of multi-part gzip file, part number present
// bit 2 set: extra field present
// bit 3 set: original file name present
// bit 4 set: file comment present
// bit 5 set: file is encrypted, encryption header present
// bit 6,7:   reserved
// 4      4 bytes  file modification time in Unix format
// 8      1 byte   extra flags (depend on compression method)
// 9      1 byte   OS type
//     [
//     2 bytes  optional part number (second part=1)
// ]?
//     [
//         2 bytes  optional extra field length (e)
//     (e)bytes  optional extra field
//     ]?
//         [
//             bytes  optional original file name, zero terminated
//         ]?
//             [
//                 bytes  optional file comment, zero terminated
//             ]?
//                 [
//                     12 bytes  optional encryption header
//                 ]?
//                     bytes  compressed data
//             4 bytes  crc32
// 4 bytes  uncompressed input size modulo 2^32
class ZLib {


    //==============================================================================================
    // Inflates a PerfectForms <Form></Form>, as received as a payload from the service.
    // This implementation uses a series of simple functions to process the states of the
    // payload.
    //
    // Dependencies --
    // pako:  A pure JavaScript implementation of Gzip.
    //
    // Assumptions -- payload, aftr decoding from base 64, always contains a 10-element GZIP header,
    // that we ignore(!)
    //
    // Returns an object containing the inflated payload in its out value (for near-term historical
    // reasons)
    //
    //==============================================================================================
    decompressForm (compressed ) {

        const decoded = Base64Decoder.decodeToArray( compressed );
        const str = pako.inflate( decoded.slice(10), { to: 'string'} );
        return str;
    }


    /*
     // ActionScript version:
     public static function compress(srcBytes: ByteArray):ByteArray    {
     // gzip is little-endian
     var outStream:ByteArray = new ByteArray();
     outStream.endian = Endian.LITTLE_ENDIAN;

     // 1 byte ID1 -- should be 31/0x1f
     outStream.writeByte(31);

     // 1 byte ID2 -- should be 139/0x8b
     outStream.writeByte(139);

     // 1 byte CM -- should be 8 for DEFLATE
     outStream.writeByte(8);

     // 1 byte FLaGs
     outStream.writeByte(0); // parseInt("00000000", 2);

     // 4 bytes MTIME (Modification Time in Unix epoch format; 0 means no time stamp is available)
     outStream.writeUnsignedInt(0);

     // 1 byte XFL (flags used by specific compression methods)
     outStream.writeByte(0); // parseInt("00000000", 2);

     // 1 byte OS -- 255-unknown
     outStream.writeByte(255);

     // calculate crc32 and filesize before compressing data
     var crc32Gen: CRC32 = new CRC32();
     crc32Gen.update(srcBytes);
     var crc32:uint = crc32Gen.getValue();

     var isize:uint = srcBytes.length % Math.pow(2, 32);

     // Actual compressed data (up to end - 8 bytes)
     srcBytes.compress();  // NOTE: ByteArray default places anohter gzip header into the compressed srcBytes!

     // Write data
     outStream.writeBytes(srcBytes, 0, srcBytes.length);

     // 4 bytes CRC32
     outStream.writeUnsignedInt(crc32);

     // 4 bytes ISIZE (input size -- size of the original input data modulo 2^32)
     outStream.writeUnsignedInt(isize);

     // Done
     return outStream;
     }
     */

    convertToHtmlCode(text) {
        if (!text) {
            return text;
        }
        let result = '';
        for (let i = 0; i < text.length; i++) {
            if (text.charCodeAt(i) > 127) {
                result += '&#' + text.charCodeAt(i) + ';';
            }
            else {
                result += text.charAt(i);
            }
        }
        return result;
    }

    compressForm(srcString) {
        let srcS = this.convertToHtmlCode(srcString);

        // Join any number of one kind of array
        function concatenate(resultConstructor, ...arrays) {
            let totalLength = 0;
            for (let arry of arrays) {
                totalLength += arry.length;
            }
            const result = new resultConstructor(totalLength);
            let offset = 0;
            for (let arry of arrays) {
                result.set(arry, offset);
                offset += arry.length;
            }
            return result;
        }

        // Generate check array: four bytes of CRC32 followed by four bytes of modulo 2^32 source length
        function genCheck( s ) {

            const
                byteMask = 0xff,
                crc32 = CRC32.str(s),
                isize = s.length % Math.pow(2, 32),
                check = [];

            // Convert to eight-byte native JS array
            for (let offset = 0; offset < 32; offset += 8 ) {
                check.push( (crc32 >>> offset) & byteMask );
            }

            for (let offset = 0; offset < 32; offset += 8 ) {
                check.push( (isize >>> offset) & byteMask );
            }

            return check;
        }

        const
            option = {header: {hcrc: true, os: 255}},
            check = genCheck(srcS),
            redundantHdr = new Uint8Array([31, 139, 8, 0, 0, 0, 0, 0, 0, 255]),
            compressed = pako.deflate(srcS, option),
            checkArray = new Uint8Array(check);

        let concatenateArray = concatenate(Uint8Array, redundantHdr, compressed, checkArray);
        let converted='';
        concatenateArray.forEach((array)=>{
            converted += String.fromCharCode(array)
        });

        return window.btoa(converted);

        // PF-4536 Commenting as for large forms, the byte array buffer throws call stack errors being exceeded, so I converted bytes to string one by one, and left the old implementation just for reference.
        // const base64Encoded = window.btoa(
        //     String.fromCharCode.apply(null, concatenate(Uint8Array, redundantHdr, compressed, checkArray)));

        // return base64encoded
    }


    //==============================================================================================
    // This method can process "normal" gzipped basecode64., but I've found no such case in
    // Perfect Forms.
    //==============================================================================================
    decompress( base64Content ) {

        const binData     = Base64Decoder.decodeToArray( base64Content );

        if ( binData[0] !== 0x1f ){
            throw `zLib.decompress: offset 0 not 0x1f`;
        }

        if ( binData[1] !== 0x8b ){
            throw `zLib.decompress: offset 1 not 0x8b`;
        }

        if ( binData[2] !== 0x08 ) {
            throw `zLib.decompress: offset 2 not 0x08 : decompress`;
        }

        // Pako inflate
        const data        = pako.inflate( binData, { to: 'string' });

        return data;
    }

}

const zLib = new ZLib();
export default zLib;
